module.exports = __webpack_public_path__ + "img/junior.ac48b33e.jpeg";